<template>
    <div>
        <div class="row">
            <div class="col">
                <h1>Create Branch Info</h1>
            </div>

            <!-- <div class="col-auto">
                <locale-switcher @change="fetchAgain" />
            </div> -->
        </div>

        <form class="mt-4" @submit.prevent="createBranchInfo">

            <div class="form-group">
                <label for="parent">
                    <small class="text-muted">BRANCH</small>
                </label>
                <select class="form-control" name="parent" v-model="branch_id" :disabled="loading">
                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                        {{ branch.name }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <label>
                    <small class="text-muted">Phones</small>
                </label>
                <input type="text" class="form-control" :placeholder="Phones" v-model="phone" autofocus
                    :disabled="loading" />
            </div>

            <div class="form-group">
                <label>
                    <small class="text-muted">Details</small>
                </label>
                <input type="text" class="form-control" :placeholder="Address" v-model="address" autofocus
                    :disabled="loading" />
            </div>

            <button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading"
                :class="{ running: loading }">
                {{ loading ? "Creating…" : "Create" }}
                <div class="ld ld-ring ld-spin" />
            </button>
        </form>

        <div class="alert alert-danger mt-4" v-if="!loading && error">
            <p class="mb-0 text-center">
                {{ error }}
            </p>
        </div>
    </div>
</template>
  
  
<script>
import { getError } from "../../../helpers";
import FileInput from "../../FileInput";
import store from "../../../store";
import { mapState } from "vuex";
import LocaleSwitcher from '../../LocaleSwitcher';

export default {
    components: {
        "file-input": FileInput,
        // 'locale-switcher': LocaleSwitcher,
    },

    data() {
        return {
            branch_id: null,
            phone: "",
            address: "",
            loading: false,
            error: "",
        };
    },

    methods: {
        async fetchAgain() {
            this.loading = true;

            await store.dispatch("branches/fetchEverything");
            next((vm) => {
                if (to.query.parent) vm.parent_id = to.query.parent;
            });
            this.loading = false;
        },
        
        createBranchInfo() {
            this.loading = true;

            this.$store
                .dispatch("branchInfo/create", {
                    branch_id: this.branch_id,
                    phone: this.phone,
                    address: this.address,
                })
                .then(() => {
                    this.$router.push({ name: "settings" });
                })
                .catch((e) => {
                    this.error = getError(e);
                    this.loading = false;
                });
        },

    },

    computed: {
        ...mapState({
            branches: state => state.branches.branches,
        }),
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch("branches/fetchEverything");
        next((vm) => {
            if (to.query.parent) vm.parent_id = to.query.parent;
        });
    },



    meta: {
        title: "Create a Branch-info",

        meta: [{ property: "og:title", content: "Create a Branch-info / Shayah" }],
    },
};
</script>
  